import { TranslateObject } from "./translate-object.interface";

export class StepsSaveObject {
    Name = new TranslateObject();
    RoleId = null;
    Statuses = [];
}
